const SINGAPORE_UEN_PATTERN =
  /(?:^|[^A-Z0-9])(\d{8,9}[A-Z]|[STFG]\d{2}[A-Z0-9]{2}\d{4}[A-Z])(?=$|[^A-Z0-9])/g;
const ACRA_BIZFILE_PAGE_LIMIT = 5;

function getSingaporeUens(text: string): string[] {
  const uniqueUens = new Set<string>();
  const normalizedText = text.toUpperCase();
  let match: RegExpExecArray | null;

  SINGAPORE_UEN_PATTERN.lastIndex = 0;
  while ((match = SINGAPORE_UEN_PATTERN.exec(normalizedText))) {
    uniqueUens.add(match[1]);
  }

  return Array.from(uniqueUens);
}

function extractUniqueSingaporeUen(text: string): string | null {
  const uens = getSingaporeUens(text);

  return uens.length === 1 ? uens[0] : null;
}

export async function extractSingaporeUenFromAcraBizFile(
  file: File
): Promise<string | null> {
  try {
    // Load PDF.js only for SG ACRA PDFs, so the default upload path stays light.
    const [pdfjs, pdfjsWorker] = await Promise.all([
      import('pdfjs-dist/es5/build/pdf'),
      import('./pdfjsWorker'),
    ]);
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker.default;

    const arrayBuffer = await file.arrayBuffer();
    const loadingTask = pdfjs.getDocument({
      data: new Uint8Array(arrayBuffer),
    });
    const pdfDocument = await loadingTask.promise;
    const pageTexts: string[] = [];
    const pageLimit = Math.min(pdfDocument.numPages, ACRA_BIZFILE_PAGE_LIMIT);

    try {
      for (let pageNumber = 1; pageNumber <= pageLimit; pageNumber++) {
        const page = await pdfDocument.getPage(pageNumber);
        const textContent = await page.getTextContent();
        const pageText = textContent.items
          .map(item => ('str' in item ? item.str : ''))
          .join(' ');

        pageTexts.push(pageText);
      }
    } finally {
      await pdfDocument.destroy?.();
    }

    return extractUniqueSingaporeUen(pageTexts.join(' '));
  } catch {
    return null;
  }
}
